import {Question} from '@/types/content/Question';

export const Chapter3Questions: Question[] = [
  {
    headline: '第3章　中古自動車の査定に係わる法規',
    introduction: '次の文は、道路運送車両の保安基準及び保安基準の細目を定める告示である。\n（ 　）のうち条文に合うものを選び、該当する番号を押してください。',
    text: '安定性［保安基準第5条］（細目告示第164条）\n空車状態及び積載状態におけるかじ取り車輪の接地部にかかる荷重の総和が、それぞれ車両重量及び車両総重量の（　１．5％ ．２．10％．3．20％　）以上であること。',
    answers: [
      {
        label: '1',
        correct: false,
      },
      {
        label: '2',
        correct: false,
      },
      {
        label: '3',
        correct: true,
      },
    ],
    description: '※テキストP26　②安定性を参照してください。',
    imageFilePath: null,
    exampleImageFilePath: null,
  },
  {
    headline: '第3章　中古自動車の査定に係わる法規',
    introduction: '次の文は、道路運送車両の保安基準及び保安基準の細目を定める告示である。\n（ 　）のうち条文に合うものを選び、該当する番号を押してください。',
    text: '前部霧灯［保安基準第33条］（細目告示第199条）前部霧灯は、\n同時に（　１．2個　　２．3個　　３．6個　）以上点灯しないように取り付けられていること。',
    answers: [
      {
        label: '1',
        correct: false,
      },
      {
        label: '2',
        correct: true,
      },
      {
        label: '3',
        correct: false,
      },
    ],
    description: 'テキストP30　⑪前部霧灯を参照してください。',
    imageFilePath: null,
    exampleImageFilePath: null,
  },
  {
    headline: '第3章　中古自動車の査定に係わる法規',
    introduction: '次の文は、道路運送車両の保安基準及び保安基準の細目を定める告示である。\n（ 　）のうち条文に合うものを選び、該当する番号を押してください。',
    text: '方向指示器［保安基準第41条］（細目告示第215条）\n方向指示器は、方向の指示を表示する方向（　1．100m　 2．150m 　3．200m）の位置から、昼間において点灯を確認できるものであり、かつ、その照射光線は、他の交通を妨げないものであること。',
    answers: [
      {
        label: '1',
        correct: true,
      },
      {
        label: '2',
        correct: false,
      },
      {
        label: '3',
        correct: false,
      },
    ],
    description: 'テキストP31　⑬方向指示器を参照してください。',
    imageFilePath: null,
    exampleImageFilePath: null,
  },
];
